const timesheetApprovalServiceName = "/TimesheetApproval";

export function timesheetApprovalService(http) {
    return {
        getUserRolesQuery: userProfileID => {            
            return http.post(timesheetApprovalServiceName + "/GetDisciplineHrCode", { userProfileID });
        },
        getAllTimesheetConfirmations: async (query, personnelCode, year, month, check, excelExport = false) => {        
            const data = {
                JSONString: query,
                Year: year,
                Month: month,
                PersonnelCode: personnelCode,
                Check: check,
                excelExport
            }
            return await http.post(timesheetApprovalServiceName + "/GetAllTimesheetConfirmations", data)
        },
        getAllTimesheetConfirmationsExcelExport: async (query, personnelCode, year, month, check, excelExport = false) => {
            const data = {
                JSONString: query,
                Year: year,
                Month: month,
                PersonnelCode: personnelCode,
                Check: check,
                excelExport
            }

            return await http.post(timesheetApprovalServiceName + "/GetAllTimesheetConfirmationsOutputExcel", data,
            { responseType: "blob" });
        },        
        approveTimesheetDataItems : (selectedUsersList) => {
            //     const dataParams = {
            //     activityCode, 
            //     activityDescription, 
            //     activityDiscipline, 
            //     basic, 
            //     batchProcessingItem, 
            //     confirmedOvertime,
            //     costCenterCode, 
            //     fullName, 
            //     hasDirectorManagerApprived, 
            //     hasFirstApproved, 
            //     hasSecondApproved,
            //     id, 
            //     mission, 
            //     overTime, 
            //     personnelCode
            // };

            return http.post(timesheetApprovalServiceName + "/ApproveSelectedTimesheetItems", selectedUsersList)
        }
    }
}
